
enum localStorageKeys{
  tokenInfo = "userLoginInfo",
}
export default localStorageKeys